import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../utils/apiClient";
import UploadWidget from "../UploadWidget.jsx";
import Navbar from "../Navbar.jsx";
import Foooter from "../Foooter.jsx";
import FooterMovil from "../FooterMovil.jsx";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import "../../style/AddCar.css";
import { useAuth } from "../../context/AuthContext.js";
import ModalDelete from "../ModalDelete";

function EditCar() {
  const location = useLocation();
  const carroToEdit = location.state?.carro || null;
  
  const [username, setUsername] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [, setSelectedBrandID] = useState("");
  const [selectedUBI, setSelectedUBI] = useState("");
  const [selectedgastype, setSelectedgastype] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedCondition, setSelectedCondition] = useState("");
  const [selectedTrans, setSelectedTrans] = useState("");
  const [selectedTrac, setSelectedTrac] = useState("");
  const [images, setImages] = useState([]);
  const [mainImage, setMainImage] = useState(null);
  const [imageToDelete, setImageToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { authToken, logout } = useAuth();
  const navigate = useNavigate();

  const handleSelectMainImage = (url) => {
    setMainImage(url);
  };

  const handleDeleteImage = (url) => {
    setImageToDelete(url);
    setShowDeleteModal(true);
  };

  const confirmDeleteImage = () => {
    setImages((prevImages) =>
      prevImages.filter((image) => image !== imageToDelete)
    );
    if (mainImage === imageToDelete) {
      setMainImage(images[0] || null);
    }
    setShowDeleteModal(false);
    setImageToDelete(null);
    };

    const cancelDeleteImage = () => {
      setShowDeleteModal(false);
      setImageToDelete(null);
    };

  const ifedit = async () => {
    setInputValues({
      millaje: carroToEdit.millaje,
      precio: carroToEdit.precio,
      motor: carroToEdit.motor,
      anio: carroToEdit.anio,
      comentario: carroToEdit.comentario,
      listado: carroToEdit.listado,
      precioOferta: carroToEdit.precioOferta,
      lote: carroToEdit.lote,
      enlace: carroToEdit.link360

    });
    setImages(carroToEdit.imagenes);
    setSelectedBrand(carroToEdit.marca);
    await HandleBrandChangeUpdate(carroToEdit.marca);
    setSelectedModel(carroToEdit.modelo);
    setSelectedUBI(carroToEdit.ubicacion);
    setSelectedgastype(carroToEdit.combustible);
    setSelectedType(carroToEdit.tipo);
    setSelectedCondition(carroToEdit.condicion);
    setSelectedTrans(carroToEdit.transmission);
    setSelectedTrac(carroToEdit.traccion);
    setCheckboxes({
      costosintro: carroToEdit.Introduccion,
      camina: carroToEdit.camina,
      placas: carroToEdit.costosPlacas,
      destacado: carroToEdit.destacado,
      enciende: carroToEdit.enciende,
      costosvias: carroToEdit.viasPublicas,
      grua: carroToEdit.gruaIncluida,
      costosins: carroToEdit.gastosDeInscripcion,
    });
  };

  const getMarcas = async () => {
    try {
      const res = await api.get("marcasymodelos/marca");
      setMarcas(res.data);
    } catch (error) {
      console.error("Error fetching marcas:", error);
    }
  };

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };

  useEffect(() => {
    const inicio = async () => {
      await getMarcas();

      if (!authToken) {
        navigate("/");
      } else {
        await getuser();
      }

      if (carroToEdit) {
        ifedit();
      }
    };

    inicio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, carroToEdit, navigate]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const gastypes = ["Gasolina", "Disel"];
  const typecars = [
    "Camioncito",
    "Pick Up",
    "Sedan",
    "Camioneta",
    "Cabezal",
    "Bus",
    "Camion",
  ];
  const transmisiones = ["Automatica", "Manual"];
  const tracciones = ["Delantera", "Trasera", "4x4"];
  const condiciones = ["Chocado", "Arreglado", "Buen Estado"];
  const Ubications = [
    "USA",
    "Puerto Cortez",
    "Tegucigalpa",
    "Transito",
    "San Lorenzo",
  ];

  const getmodelos = async (marcaID) => {
    try {
      const data = { marca: marcaID };
      const res = await api.post("marcasymodelos/modelobymarca", data);
      setModelos(res.data);
    } catch (error) {
      console.error("Error fetching modelos:", error);
    }
  };

  const handleBrandChange = (event) => {
    setSelectedBrand(event.target.value);
    const result = marcas.filter(
      (marca) => marca.Nombre === event.target.value
    );
    setSelectedBrandID(result[0]._id);
    getmodelos(result[0]._id);
  };

  const HandleBrandChangeUpdate = async (Brand) => {
    try {
      const res = await api.get("marcasymodelos/marca");
      const brands = res.data;
      const result = brands.filter((brand) => brand.Nombre === Brand);
      setSelectedBrandID(result[0]._id);
      getmodelos(result[0]._id);
    } catch (error) {
      console.error("Error fetching marca for update:", error);
    }
  };

  const handleModelChange = (event) => setSelectedModel(event.target.value);
  const handleTransChange = (event) => setSelectedTrans(event.target.value);
  const handleTracChange = (event) => setSelectedTrac(event.target.value);
  const handleConditionChange = (event) => setSelectedCondition(event.target.value);
  const handleTypeChange = (event) => setSelectedType(event.target.value);
  const handleUBIChange = (event) => setSelectedUBI(event.target.value);
  const handleGasChange = (event) => setSelectedgastype(event.target.value);

  const handleUploadSuccess = (url) => {
    setImages((prevImages) => [...prevImages, url]);
    if (images.length === 0) {
      setMainImage(url);
    }
  };

  const [inputValues, setInputValues] = useState({
    millaje: "",
    precio: "",
    motor: "",
    anio: "",
    comentario: "",
    enlace: "",
    listado: "",
    precioOferta: "",
    lote: "",
  });

  const [checkboxes, setCheckboxes] = useState({
    iaai: false,
    copart: false,
    grua: false,
    costosintro: false,
    enciende: false,
    camina: false,
    costosvias: false,
    costosins: false,
    placas: false,
    destacado: false,
    inscripcion: false,
  });

  const handleCheckboxChange = async (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({ ...prevCheckboxes, [name]: checked }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInputValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const filteredArray = images.filter(
      (item) =>
        item !== null && item !== undefined && item !== "" && !(Array.isArray(item) && item.length === 0)
    );
    const carData = {
      ...inputValues,
      imagenes: filteredArray,
      condicion: selectedCondition,
      marca: selectedBrand,
      modelo: selectedModel,
      tipo: selectedType,
      traccion: selectedTrac,
      transmission: selectedTrans,
      ubicacion: selectedUBI,
      combustible: selectedgastype,
      millaje: parseInt(inputValues.millaje),
      anio: parseInt(inputValues.anio),
      precio: parseInt(inputValues.precio),
      precioOferta: parseInt(inputValues.precioOferta) || 0,
      camina: checkboxes.camina,
      Introduccion: checkboxes.costosintro,
      enciende: checkboxes.enciende,
      viasPublicas: checkboxes.costosvias,
      gruaIncluida: checkboxes.grua,
      costosPlacas: checkboxes.placas,
      destacado: checkboxes.destacado,
      gastosDeInscripcion: checkboxes.costosins,
    };

    try {
      await api.post(`carro/${carroToEdit._id}`, carData);
      navigate("/allcarsa");
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  const featureChips = [
    { name: "grua", label: "Grúa incluida" },
    { name: "costosintro", label: "Costos de introducción" },
    { name: "costosins", label: "Costos de inscripción" },
    { name: "costosvias", label: "Costos de vías públicas" },
    { name: "placas", label: "Costos de placas" },
    { name: "destacado", label: "Destacado" },
    { name: "enciende", label: "Enciende" },
    { name: "camina", label: "Camina" },
  ];

  return (
    <>
      <Navbar />
      <div className="containers ac-page">
        <div className="main-container-admin-add">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info-all">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-user-title">Editar Auto</p>
            <form onSubmit={handleSubmit} className="form-container-add ac-form">
              {/* Images section */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Imágenes</h2>
                  <p className="ac-card-sub">
                    Haz clic en una miniatura para elegirla como imagen principal.
                  </p>
                </header>

                <div className="ac-upload">
                  <UploadWidget onUploadSuccess={handleUploadSuccess} />
                </div>

                {images.length > 0 ? (
                  <div className="ac-images">
                    <div className="ac-image-main">
                      <img src={mainImage || images[0]} alt="Principal" />
                      <span className="ac-image-main-badge">Principal</span>
                    </div>
                    <div className="ac-image-thumbs">
                      {images.map((url, index) => (
                        <div
                          key={index}
                          className={`ac-thumb ${mainImage === url ? "is-main" : ""}`}
                        >
                          <img
                            src={url}
                            alt={`Imagen ${index + 1}`}
                            onClick={() => handleSelectMainImage(url)}
                          />
                          <button
                            type="button"
                            className="ac-thumb-delete"
                            onClick={() => handleDeleteImage(url)}
                            aria-label="Eliminar imagen"
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p className="ac-empty">Aún no has subido imágenes</p>
                )}
              </section>

              {/* Vehicle info */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Información del vehículo</h2>
                </header>

                <div className="ac-form-grid">
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="marca">Marca</label>
                    <select
                      id="marca"
                      name="marca"
                      className="ac-select"
                      value={selectedBrand}
                      onChange={handleBrandChange}
                    >
                      <option value="">Selecciona marca</option>
                      {marcas.map((marca) => (
                        <option key={marca._id} value={marca.Nombre}>
                          {marca.Nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="modelo">Modelo</label>
                    <select
                      id="modelo"
                      name="modelo"
                      className="ac-select"
                      value={selectedModel}
                      onChange={handleModelChange}
                    >
                      <option value="">Selecciona modelo</option>
                      {modelos.map((modelo) => (
                        <option key={modelo._id} value={modelo.Nombre}>
                          {modelo.Nombre}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="anio">Año</label>
                    <input
                      id="anio"
                      name="anio"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="2015"
                      value={inputValues.anio}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="millaje">Millaje</label>
                    <input
                      id="millaje"
                      name="millaje"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="85,000"
                      value={inputValues.millaje}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="precio">Precio (L)</label>
                    <input
                      id="precio"
                      name="precio"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="250,000"
                      value={inputValues.precio}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="ubicacion">Ubicación</label>
                    <select
                      id="ubicacion"
                      name="ubicacion"
                      className="ac-select"
                      value={selectedUBI}
                      onChange={handleUBIChange}
                    >
                      <option value="">Selecciona ubicación</option>
                      {Ubications.map((u) => (
                        <option key={u} value={u}>{u}</option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="condicion">Condición</label>
                    <select
                      id="condicion"
                      name="condicion"
                      className="ac-select"
                      value={selectedCondition}
                      onChange={handleConditionChange}
                    >
                      <option value="">Selecciona condición</option>
                      {condiciones.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="motor">Motor (cc)</label>
                    <input
                      id="motor"
                      name="motor"
                      type="text"
                      className="ac-input"
                      placeholder="1800"
                      value={inputValues.motor}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="combustible">Combustible</label>
                    <select
                      id="combustible"
                      name="combustible"
                      className="ac-select"
                      value={selectedgastype}
                      onChange={handleGasChange}
                    >
                      <option value="">Selecciona combustible</option>
                      {gastypes.map((g) => (
                        <option key={g} value={g}>{g}</option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="transmision">Transmisión</label>
                    <select
                      id="transmision"
                      name="transmision"
                      className="ac-select"
                      value={selectedTrans}
                      onChange={handleTransChange}
                    >
                      <option value="">Selecciona transmisión</option>
                      {transmisiones.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field">
                    <label className="ac-label" htmlFor="traccion">Tracción</label>
                    <select
                      id="traccion"
                      name="traccion"
                      className="ac-select"
                      value={selectedTrac}
                      onChange={handleTracChange}
                    >
                      <option value="">Selecciona tracción</option>
                      {tracciones.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="tipo">Tipo</label>
                    <select
                      id="tipo"
                      name="tipo"
                      className="ac-select"
                      value={selectedType}
                      onChange={handleTypeChange}
                    >
                      <option value="">Selecciona tipo</option>
                      {typecars.map((t) => (
                        <option key={t} value={t}>{t}</option>
                      ))}
                    </select>
                  </div>

                  <div className="ac-field ac-field-full">
                    <label className="ac-label" htmlFor="lote">Lote</label>
                    <input
                      id="lote"
                      name="lote"
                      type="text"
                      className="ac-input"
                      placeholder="Número de lote"
                      value={inputValues.lote}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </section>

              {/* Additional details */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Detalles adicionales</h2>
                </header>

                <div className="ac-form-grid">
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="comentario">Comentario</label>
                    <input
                      id="comentario"
                      name="comentario"
                      type="text"
                      className="ac-input"
                      placeholder="Notas internas"
                      value={inputValues.comentario}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="listado">Listado</label>
                    <input
                      id="listado"
                      name="listado"
                      type="text"
                      className="ac-input"
                      placeholder="Listado"
                      value={inputValues.listado}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="enlace">Enlace 306</label>
                    <input
                      id="enlace"
                      name="enlace"
                      type="text"
                      className="ac-input"
                      placeholder="https://..."
                      value={inputValues.enlace}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="ac-field">
                    <label className="ac-label" htmlFor="precioOferta">Precio oferta (L)</label>
                    <input
                      id="precioOferta"
                      name="precioOferta"
                      type="text"
                      inputMode="numeric"
                      className="ac-input"
                      placeholder="180,000"
                      value={inputValues.precioOferta}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </section>

              {/* Features */}
              <section className="ac-card">
                <header className="ac-card-header">
                  <h2 className="ac-card-title">Incluye / características</h2>
                  <p className="ac-card-sub">
                    Marca todas las opciones aplicables.
                  </p>
                </header>

                <div className="ac-checks-grid">
                  {featureChips.map((item) => (
                    <label
                      key={item.name}
                      className={`ac-check-chip ${checkboxes[item.name] ? "is-checked" : ""}`}
                    >
                      <input
                        type="checkbox"
                        name={item.name}
                        checked={checkboxes[item.name] || false}
                        onChange={handleCheckboxChange}
                      />
                      <span className="ac-check-mark" aria-hidden="true">✓</span>
                      <span className="ac-check-label">{item.label}</span>
                    </label>
                  ))}
                </div>
              </section>

              <div className="ac-submit-row">
                <button type="submit" className="ac-btn ac-btn-primary ac-btn-lg">
                  Actualizar auto
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="footer">
      <Foooter />
      </div>
      <div className="footer-movil">
      <FooterMovil />
      </div>
      <ModalDelete show={showDeleteModal} onClose={cancelDeleteImage} onConfirm={confirmDeleteImage} />
    </>
  );
}

export default EditCar;